import { render, staticRenderFns } from "./modalAddCompanyToBusinessWall.vue?vue&type=template&id=cfaca1be&"
import script from "./modalAddCompanyToBusinessWall.vue?vue&type=script&lang=js&"
export * from "./modalAddCompanyToBusinessWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports